import apiClient from "../utils/axios";

export interface ReceiptEmailsResponse {
  organization_id: string;
  emails: string[];
}

export class ReceiptEmailService {
  static async getReceiptEmails(
    organizationId: string,
    token: string
  ): Promise<ReceiptEmailsResponse> {
    const response = await apiClient.get(
      `/api/organization/${organizationId}/receipt-emails`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }

  static async updateReceiptEmails(
    organizationId: string,
    emails: string[],
    token: string
  ): Promise<ReceiptEmailsResponse> {
    const response = await apiClient.put(
      `/api/organization/${organizationId}/receipt-emails`,
      { emails },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  }
}
